<template>
  <DialogContent>
    <div
      class="font-semibold font-primary text-[30px] leading-[34px] tablet-h:w-4/5! mb-3"
    >
      Some updates you should know about
    </div>
    We're updating our
    <a href="/legal/terms" class="text-link" target="_blank">
      Terms of Service
    </a>
    and
    <span class="inline-flex">
      <a href="/legal/privacy" class="text-link" target="_blank">
        Privacy Policy
      </a>
      .
    </span>
    Now's a great chance to review them.

    <UiButton class="w-full mt-5" primary @click="handleClick">Got it</UiButton>
  </DialogContent>
</template>

<script setup lang="ts">
import { UiButton } from '@dacr/ui'
import DialogContent from '@/shared/dialogs/DialogContent.vue'
import { useDialog } from '@/shared/dialogs/useDialog'
import { useAcceptTermsMutation } from '@/shared/graphql/legacy/generated'
import { useDialogOptions } from '../useDialogOptions'

const { close, triggerEvent } = useDialog()

const { mutate: acceptTerms } = useAcceptTermsMutation()

useDialogOptions({
  hideCloseButton: true,
  preventOutsideClick: true,
})

const handleClick = () => {
  acceptTerms()
  triggerEvent('success')
  close()
}
</script>
